import { Outlet } from "react-router-dom";

const CampaignPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default CampaignPageLayout;